import { DateRangeSelector } from "@/tours-agent/reports/components/DateRangeSelector";
import { useState } from "react";
import Revenue from "./Revenue";
import OrdersByGroup from "./OrdersByGroup";
import CommisionRevenue from "./CommisionRevenue";
import TotalOrders from "./TotalOrders";
import { ChartArea } from "lucide-react";

const PartnerReports = () => {
  const [dateRange, setDateRange] = useState<{
    startDate: Date;
    endDate: Date;
  }>({ startDate: new Date(), endDate: new Date() });

  return (
    <div className="shadow-md p-5 rounded-lg border">
      <div className="flex items-center space-x-2 mb-3">
        <ChartArea className="text-gray-500" />
        <h2 className="text-lg font-semibold">Your reports</h2>
      </div>
      <DateRangeSelector range={dateRange} setRange={setDateRange} />
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 
      *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:
      *:data-[slot=card]:bg-card">
        <Revenue range={dateRange} />
        <CommisionRevenue range={dateRange} />
        <TotalOrders range={dateRange} />
        <OrdersByGroup range={dateRange} />
      </div>
    </div>
  );
};

export default PartnerReports;
